module.exports = "../fonts/HelveticaNeueLTW01-35Thin.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-35Thin.svg
// module id = x/He
// module chunks = 1